import type { LinksFunction, MetaFunction } from '@remix-run/node'
import { Container } from '~/ui_components/layout/container.tsx'
import { H1 } from '~/ui_components/typography/h1.tsx'
import { H2 } from '~/ui_components/typography/h2.tsx'
import { P } from '~/ui_components/typography/p.tsx'
import barraCofinanciamento from './images/prr-barra-cofinanciamento.png'
import barraCofinanciamentoBranca from './images/prr-barra-cofinanciamento-branca.png'

export const meta: MetaFunction = () => [
	{ title: 'PRR — Plano de Recuperação e Resiliência | André Casal' },
	{ name: 'description', content: 'Projeto financiado pelo Plano de Recuperação e Resiliência (PRR), no âmbito do NextGenerationEU – União Europeia.' },
]

export const links: LinksFunction = () => [{ rel: 'canonical', href: 'https://andrecasal.com/prr' }]

export default function PRR() {
	return (
		<Container>
			<div className="mx-auto max-w-2xl py-16 sm:py-24">
				<H1 size="4xl" className="font-bold tracking-tight">
					Plano de Recuperação e Resiliência (PRR)
				</H1>

				<div className="mt-12 space-y-10">
					<section>
						<H2 size="xl" className="font-semibold">
							Nome do projeto
						</H2>
						<P size="md" className="mt-4 text-muted-600">
							LaunchFast.pro
						</P>
					</section>

					<section>
						<H2 size="xl" className="font-semibold">
							Entidade promotora
						</H2>
						<P size="md" className="mt-4 text-muted-600">
							Casal Innovations, Lda
						</P>
					</section>

					<section>
						<H2 size="xl" className="font-semibold">
							Breve descrição do projeto
						</H2>
						<P size="md" className="mt-4 text-muted-600">
							O LaunchFast.pro consiste no desenvolvimento de uma plataforma digital inovadora que permite criar, configurar e lançar produtos digitais de forma rápida,
							segura e escalável através de uma interface de linha de comandos (CLI). A solução integra funcionalidades essenciais como autenticação, pagamentos,
							monitorização, inteligência artificial e infraestrutura cloud, simplificando o processo de desenvolvimento e reduzindo significativamente o tempo e os
							custos de lançamento no mercado.
						</P>
					</section>

					<section>
						<H2 size="xl" className="font-semibold">
							Objetivos
						</H2>
						<P size="md" className="mt-4 text-muted-600">
							Desenvolver o MVP da plataforma LaunchFast.pro; criar uma solução escalável para lançamento rápido de aplicações digitais; integrar funcionalidades
							avançadas de segurança, autenticação e pagamentos; incorporar ferramentas de inteligência artificial no processo de desenvolvimento; validar o produto
							junto do mercado e preparar a sua comercialização internacional.
						</P>
					</section>

					<section>
						<H2 size="xl" className="font-semibold">
							Investimento elegível
						</H2>
						<P size="md" className="mt-4 text-muted-600">
							30.000,00 €
						</P>
					</section>

					<section>
						<P size="md" className="font-semibold">
							Este projeto é financiado pelo Plano de Recuperação e Resiliência (PRR), no âmbito do NextGenerationEU – União Europeia
						</P>
					</section>

					<section>
						<a href="https://recuperarportugal.gov.pt/" target="_blank" rel="noreferrer">
							<img src={barraCofinanciamento} alt="Logotipos PRR — Plano de Recuperação e Resiliência, República Portuguesa e Financiado pela União Europeia — NextGenerationEU" className="w-full dark:hidden" />
							<img
								src={barraCofinanciamentoBranca}
								alt="Logotipos PRR — Plano de Recuperação e Resiliência, República Portuguesa e Financiado pela União Europeia — NextGenerationEU"
								className="hidden w-full dark:block"
							/>
						</a>
					</section>

					<section>
						<P size="md" className="mt-4 text-muted-600">
							Mais informação sobre o Plano de Recuperação e Resiliência em{' '}
							<a href="https://recuperarportugal.gov.pt/" target="_blank" rel="noreferrer" className="font-semibold underline underline-offset-4 hover:text-brand">
								recuperarportugal.gov.pt
							</a>
							.
						</P>
					</section>
				</div>
			</div>
		</Container>
	)
}
